import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Tween } from '@tweenjs/tween.js';
import { delay } from '../../../Utility/Task/TaskQueue';
import ElementComponent from '../../../Component/UI/Element';
import { DEG_TO_RAD } from 'pixi.js';

export class Wiggle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: {
            duration: number;
            delay?: number;
            loop?: boolean;
            rotationAngle?: number;
        }
    ): IterableIterator<number> {
        meta.delay = meta.delay || 0;
        const elementComponent: ElementComponent = gameObject.getComponent(
            ElementComponent
        );
        const rotationTween: Tween = this.getTween(elementComponent);

        yield* this.wiggle(rotationTween, meta.duration);

        while (meta.loop) {
            yield* this.wiggle(
                rotationTween,
                meta.duration,
                meta.rotationAngle
            );
            yield* delay(meta.delay);
        }
    }

    private *wiggle(
        rotationTween: Tween,
        duration: number,
        rotationAngle?: number
    ): IterableIterator<number> {
        const angleOne_RAD: number =
            rotationAngle !== undefined
                ? rotationAngle * DEG_TO_RAD
                : Math.PI * 0.1;
        const angleTwo_RAD: number = -angleOne_RAD;
        yield* this.rotationTo(rotationTween, angleOne_RAD, duration);
        yield* this.rotationTo(rotationTween, angleTwo_RAD, duration);
        yield* this.rotationTo(rotationTween, angleOne_RAD, duration);
        yield* this.rotationTo(rotationTween, angleTwo_RAD, duration);
        yield* this.rotationTo(rotationTween, angleOne_RAD, duration);
        yield* this.rotationTo(rotationTween, angleTwo_RAD, duration);
        yield* this.rotationTo(rotationTween, 0, duration);
    }

    private *rotationTo(
        tween: Tween,
        rotation: number,
        delay: number
    ): IterableIterator<number> {
        tween.to({ rotation: rotation }, delay);
        yield* this.startTween(tween);
    }
}
